import { TextInput } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import type { ReturnOrderFormSchema } from "@msuite/utils/schemas";
import { useFormContext } from "react-hook-form";
import { ProjectSearch } from "@/components/projects";
import { ReturnOrderFormVehicles } from "./return-order-form-vehicles";

/**
 * Raising a return: the site being cleared, the trucks fetching it, and a note for whoever loads.
 *
 * There is no article list, and that is the shape of the domain rather than a gap — a return is
 * raised before anybody knows what will come back, and the lines are the bookings made when the
 * truck arrives.
 */
export function ReturnOrderForm() {
	/** Context */
	const methods = useFormContext<ReturnOrderFormSchema>();

	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<div className="gap-4 v-stack">
			<ProjectSearch
				onChange={(projectId) => {
					if (projectId) methods.setValue("projectId", projectId);
				}}
				defaultProjectId={methods.getValues("projectId")}
				isNullable={false}
			/>
			<ReturnOrderFormVehicles />
			<TextInput
				label={t("notes.note")}
				control={methods.control}
				name="note"
				isRequired={false}
			/>
		</div>
	);
}
